import React, { useState } from "react";

function TokenBox({ onSubmit }) {
  const [token, setToken] = useState("");
  const [visible, setVisible] = useState(false);

  const handleSubmit = () => {
    if (token.trim()) onSubmit(token);
  };

  return (
    <div style={{ marginTop: "30px" }}>
      <label className="form-label">Enter JWT Token</label>

      <div className="jwt-input-box">
        <textarea
          placeholder="Paste JWT here..."
          value={visible ? token : token.replace(/./g, "•")}
          onChange={(e) => setToken(e.target.value)}
          style={{
            width: "100%",
            height: "90px",
            border: "none",
            background: "transparent",
            fontFamily: "monospace",
            fontSize: "14px",
            outline: "none",
            resize: "none"
          }}
        />

        {/* Eye Icon */}
        <svg
          onClick={() => setVisible(!visible)}
          className="icon-btn"
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
        >
          {visible ? (
            <path
              d="M2 2L22 22"
              stroke="#333"
              strokeWidth="2"
              strokeLinecap="round"
            />
          ) : (
            <path
              d="M12 5C7 5 2.7 8.1 1 12c1.7 3.9 6 7 11 7s9.3-3.1 11-7c-1.7-3.9-6-7-11-7z"
              stroke="#333"
              strokeWidth="2"
            />
          )}
        </svg>
      </div>

      <button onClick={handleSubmit} className="primary-btn">
        Login with JWT
      </button>
    </div>
  );
}

export default TokenBox;
